import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Container,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  useMediaQuery,
} from '@material-ui/core';

import Backdrop from '../ReservaFrom/Backdrop';
import TrainIcon from '@material-ui/icons/Train';

//actions
import { enviarAutorizacion } from '../../redux/actions/autorizacionActions';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  imageQr: {
    width: '100%',
  },
  center: {
    textAlign: 'center',
    fontSize: 'large',
  },
  red: {
    color: '#ff2323fc',
  },
  white: {
    color: '#fff',
  },
  bred: {
    background: '#ff5c5cfc',
    color: '#ffffff',
    padding: '2px 8px 2px 8px',
  },
  footerModalAction: {
    borderTop: '1px solid #ccc',
    borderBottom: '10px solid #01579b',
  },
  titleDialog: {
    background: '#01579b',
    color: '#ffffff',
  },
  botonXs: {
    position: 'relative',
    marginTop: '12px;',
  },
}));

export default ({ open, setOpen, reserva }) => {
  const classes = useStyles();

  const quiebre = useMediaQuery('(max-width:500px)');

  const { token } = useSelector((state) => state.auth);
  const { error } = useSelector((state) => state.autorizaciones);

  const [success, setSuccess] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  function handleAgregarAutorizacion(servicioId) {
    const servicio = {
      serviciosSeleccionados: {
        ida: {
          servicio: {
            servicioId: servicioId,
            desdeId: reserva.servicio.desde.id,
            hastaId: reserva.servicio.hasta.id,
            cantidad: 1,
          },
        },
      },
    };

    dispatch(
      enviarAutorizacion(token, reserva.servicioId, servicio, setSuccess, reserva.id)
    );
    setOpen(false);
    setOpenBackdrop(true);
  }

  useEffect(() => {
    if (success) {
      setSuccess(false);
      setOpenBackdrop(false);
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      setOpenBackdrop(false);
    }
  }, [error]);

  return (
    <>
      <Backdrop open={openBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        fullWidth={true}
        maxWidth={'md'}
      >
        <DialogTitle id='alert-dialog-title' className={classes.titleDialog}>
          {'Servicios sugeridos para tu viaje cancelado'}
        </DialogTitle>
        <DialogContent>
          <Container className={classes.center}>
            <List>
              {reserva.serviciosSugeridos.map((a) => (
                <ListItem key={a.servicio_id}>
                  {!quiebre && (
                    <ListItemAvatar>
                      <Avatar>
                        <TrainIcon />
                      </Avatar>
                    </ListItemAvatar>
                  )}
                  <ListItemText
                    primary={` TREN ${a.numero} a las ${a.fecha_hora.substr(0, 5)} `}
                  />
                  <ListItemSecondaryAction
                    className={quiebre ? classes.botonXs : ''}
                    // style={quiebre ? { position: 'relative', marginTop: '12px;' } : {}}
                  >
                    <Button
                      variant='contained'
                      color='secondary'
                      className={classes.white}
                      onClick={() => handleAgregarAutorizacion(a.servicio_id)}
                    >
                      Reservar
                    </Button>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </Container>
        </DialogContent>
        <DialogActions className={classes.footerModalAction}>
          <Button onClick={handleClose} color='primary'>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
